export class SpeakerInstructorBlock {
    constructor() { 
        let speakerBlockList = document.querySelectorAll(".speaker-block-details-description");
        let speakerBlockArray = Array.prototype.slice.call(speakerBlockList);

        speakerBlockArray.forEach(function (speakerBlock) {
            let speakerBlockBtn = speakerBlock.querySelector(".speaker-block-details-btn");
            if (speakerBlockBtn) {
                let speakerBlockBtnId = speakerBlockBtn.id;
                document.getElementById(speakerBlockBtnId).addEventListener("click", function () {
                    if (speakerBlockBtn.parentElement.classList.contains("speaker-block-details-description-closed")) {
                        speakerBlockBtn.parentElement.classList.remove("speaker-block-details-description-closed");
                        speakerBlockBtn.parentElement.classList.add("speaker-block-details-description-open");
                        (<HTMLInputElement>document.getElementById(speakerBlockBtnId)).value = "Read Less";
                    }
                    else if (speakerBlockBtn.parentElement.classList.contains("speaker-block-details-description-open")) {
                        speakerBlockBtn.parentElement.classList.remove("speaker-block-details-description-open");
                        speakerBlockBtn.parentElement.classList.add("speaker-block-details-description-closed");
                        (<HTMLInputElement>document.getElementById(speakerBlockBtnId)).value = "Read More";
                    }
                })
            }
        })          
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/speaker-instructor-block.ts